import { memo } from "react";
import { FormGroup, FormControlLabel, Checkbox, Grid } from "@mui/material";
import { useFormContext } from "@4uhub/lib4uhub";
import { useWatch } from "react-hook-form";
import { serviceTypes } from "../service-period.mock";
import { TServicePeriodForm } from "./servicePeriodSchema";

const translationPath = "page.4uDlist.generationRule.servicePeriod.";

export const CheckboxesSection = memo(() => {
  const { setValue, control } = useFormContext<TServicePeriodForm>();

  const serviceType =
    useWatch({
      control,
      name: "serviceType",
    }) || [];

  const handleChange = (label: string) => {
    const isSelected = serviceType.includes(label);

    if (isSelected) {
      setValue(
        "serviceType",
        serviceType.filter((item: string) => item !== label),
      );
    } else {
      setValue("serviceType", [...serviceType, label]);
    }
  };

  return (
    <Grid item xs={12}>
      <FormGroup>
        {serviceTypes.map((opt) => (
          <FormControlLabel
            key={opt.id}
            label={opt.label}
            sx={{ width: "fit-content" }}
            control={
              <Checkbox
                checked={serviceType.includes(opt.label)}
                onChange={() => handleChange(opt.label)}
              />
            }
          />
        ))}
      </FormGroup>
    </Grid>
  );
});
